<template>
    <div class="stepTwo">
        <headers></headers>
        <div class="content">
            <steps :step-num="1"></steps>
            <div class="stepTwo-content" v-if="isCommon">
                <div class="stepTow-tip"><Icon type="md-alert" /> <p>检测到您在我校已绑定手机号 {{phoneNum}}，如需修改，请先进行人脸核身验证。 <a @click="goYz">去验证></a></p></div>
                <div class="stepTwo-form">
                    <p class="stepTwo-myphone">手机号: {{phoneNum}}</p>
                    <Row>
                        <Col span="16"><Input v-model="value" placeholder="请输入验证码" /></Col>
                        <Col span="1"></Col>
                        <Col span="5"><Button type="primary" :disabled="isDisable2" @click.native="getMobileCode2">{{getText2}}</Button></Col>
                    </Row>
                    <Button style="margin-top: 50px" type="primary" long @click="handleSubmit2">下一步</Button>
                </div>
            </div>
            <div class="stepTwo-content" v-if="isUpload">
                <div class="stepTwo-form">
                        <Spin fix v-if="isUploaded">
                            <Icon type="ios-loading" size=30 class="demo-spin-icon-load"></Icon>
                            <div>人脸核身验证中，请勿操作，请稍后...</div>
                        </Spin>
                    <div v-if="userImg == ''">
                        <div class="upload-box">
                            <Icon type="ios-images" />
                            <input type="file" id="imgId" name="image" class="imgFile" @change="changeImg($event)" accept="image/jpeg,image/jpg,image/png">
                        </div>
                        <p style="margin-top: 20px;font-size: 14px">请上传图片进行人脸核身，验证成功后可继续绑定手机号。</p>
                    </div>
                    <div class="upload-box2" v-if="!isUploaded && userImg != ''">
                        <img class="user-img" :src="userImg" alt="">
                        <div class="go-bind">已完成人脸核身，<a @click="bindPhone">绑定手机></a></div>
                    </div>
                </div>

            </div>
            <div class="stepTwo-content" v-if="isTextPhone">
                <div class="stepTwo-form">
                    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="0">
                        <FormItem prop="phone">
                            <Input v-model="formValidate.phone" placeholder="请输入您的手机号"></Input>
                        </FormItem>
                        <FormItem prop="code">
                            <Row>
                                <Col span="16"><Input v-model="formValidate.code" placeholder="请输入验证码"></Input></Col>
                                <Col span="1"></Col>
                                <Col span="5"><Button type="primary" :disabled="isDisable" @click.native="getMobileCode">{{getText}}</Button></Col>
                            </Row>
                        </FormItem>
                        <FormItem>
                            <Button type="primary" long @click="handleSubmit('formValidate')">下一步</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import headers from '../../components/pc/header.vue'
    import steps from '../../components/pc/mStep.vue'
    import * as utils from '../../utils'
    export default {
        name: "stepTwo",
        components: {
            headers,
            steps
        },
        data() {
            return {
                isDisable: true,
                isDisable2: false,
                getText: '获取验证码',
                getText2: '获取验证码',
                isUploaded: false,
                hasBind: false,
                hasBinds: false,
                formValidate: {
                    phone: '',
                    code: ''
                },
                ruleValidate: {
                    phone: [{ required: true, message: '请输入您的手机号', trigger: 'blur' }],
                    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                },
                value: '',
                faceBase64: '',
                userImg: '',
                visible: false,
                isCommon: false,
                isTextPhone: false,
                isUpload: false,
                uploadList: [],
                defaultList: []
            }
        },
        watch: {
            'formValidate.phone'(val) {
                if(val != '') {
                    this.isDisable = false
                } else {
                    this.isDisable = true
                }
            },
            hasBinds(val) {
                if(val) {
                    this.isDisable2 = true
                    let times = 60
                    let interval = setInterval(() => {
                        this.getText2 = times + 's'
                        times--;
                        if(times == 0) {
                            clearInterval(interval)
                            this.hasBinds = false
                        }
                    },1000)
                } else {
                    this.isDisable2 = false
                    this.getText2 = '获取验证码'
                }
            },
            hasBind(val) {
                if(val) {
                    this.isDisable = true
                    let times = 60
                    let interval = setInterval(() => {
                        this.getText = times + 's'
                        times--;
                        if(times == 0) {
                            clearInterval(interval)
                            this.hasBind = false
                        }
                    },1000)
                } else {
                    this.isDisable = false
                    this.getText = '获取验证码'
                }
            }
        },
        computed: {
            ...mapState({
                userInfos: state=>state.userInfo,
                cardIds: state=>state.cardId,
            }),
            phoneNum() {
                if(this.userInfos.phone) {
                    return this.userInfos.phone.substr(0,3)+'****'+this.userInfos.phone.substr(7,11)
                }else {
                    return ''
                }
            }
        },
        created() {
            if(!this.userInfos.sessionId) {
                this.$router.push({path: '/stepMoOne',query: {service: this.$route.query.service}})
            }
            if(this.userInfos.phone) {
                this.isCommon = true
            } else {
                this.isUpload = true
            }
        },
        methods: {
            getMobileCode2() {
                if(!this.isDisable2) {
                    utils.Post('https://id.scuec.edu.cn/activateAccount/sendActivateSms',{
                        sessionId: this.userInfos.sessionId,
                        userAccount: this.userInfos.userAccount,
                        phone: this.userInfos.phone,
                    }).then(res => {
                        if(res.data.data) {
                            this.$Message.success('验证码已发送')
                            this.hasBinds = true
                        } else {
                            this.$Message.error(res.data.errMsg)
                        }
                    })
                }
            },
            getMobileCode() {
                if(!this.isDisable) {
                    if(!(/^1[3456789]\d{9}$/.test(this.formValidate.phone))){
                        this.$Message.warning('请输入正确的手机号')
                        return
                    }
                    utils.Post('https://id.scuec.edu.cn/activateAccount/sendActivateSms',{
                        sessionId: this.userInfos.sessionId,
                        userAccount: this.userInfos.userAccount,
                        phone: this.formValidate.phone,
                    }).then(res => {
                        if(res.data.data) {
                            this.$Message.success('验证码已发送')
                            this.hasBind = true
                        } else {
                            this.$Message.error(res.data.errMsg)
                        }
                    })
                }
            },
            bindPhone() {
                this.isUpload = false
                this.isTextPhone = true
            },
            changeImg(e) {
                let files = document.getElementById('imgId').files[0]
                let name = document.getElementById('imgId').files[0].name
                let arr = name.split('.')
                let fileSize = 0;
                let fileMaxSize = 20480;//2M
                if(files){
                    fileSize =files.size;
                    if (fileSize > 3*1024*1024) {
                        this.$Message.error("文件大小不能大于3M！")
                        files.value = "";
                        return false;
                    }else if (fileSize <= 0) {
                        this.$Message.error("文件大小不能为0M！")
                        files.value = "";
                        return false;
                    }
                }else{
                    return false;
                }

                //转码base64
                let reader = new FileReader();
                let imgFile
                // let that = this
                reader.readAsDataURL(files)
                reader.onload = e => {
                    imgFile = e.target.result;
                    let arr = imgFile.split(',')
                    this.faceBase64 = arr[1]
                    this.formartImg(arr)
                }
            },
            formartImg(arr) {
                this.isUploaded = true
                utils.Post('https://id.scuec.edu.cn/activateAccount/imageRecognition',{
                    idCard: this.cardIds,
                    name: this.userInfos.userName,
                    imageBase64: this.faceBase64
                }).then(res => {
                    this.isUploaded = false
                    if(res.data.code == 'success') {
                        let data = JSON.parse(res.data.data);
                        if(data.Sim >= 70) {
                            this.userImg = arr[0]+','+arr[1]
                        } else {
                            this.$Message.error(data.Description);
                        }
                    } else {
                        this.$Message.error('人脸核身失败，请重试')
                        document.getElementById('imgId').files[0].value = ''
                    }
                })
            },
            handleSubmit2() {
                if (this.value != '') {
                    utils.Post('https://id.scuec.edu.cn/activateAccount/checkSmsVerificationCode',{
                        sessionId: this.userInfos.sessionId,
                        userAccount: this.userInfos.userAccount,
                        phone: this.userInfos.phone,
                        verificationCode: this.value
                    }).then(res => {
                        if(res.data.errCode == '0') {
                            this.$router.push({path: '/stepMoThree',query: {service: this.$route.query.service}})
                        } else {
                            this.$Message.error(res.data.errMsg)
                        }
                    })
                } else {
                    this.$Message.error('请输入验证码')
                }
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        utils.Post('https://id.scuec.edu.cn/activateAccount/checkSmsVerificationCode',{
                            sessionId: this.userInfos.sessionId,
                            userAccount: this.userInfos.userAccount,
                            phone: this.formValidate.phone,
                            verificationCode: this.formValidate.code
                        }).then(res => {
                            if(res.data.errCode == '0') {
                                this.$router.push({path: '/stepMoThree',query: {service: this.$route.query.service}})
                            } else {
                                this.$Message.error(res.data.errMsg)
                            }
                        })
                    }
                })

            },
            goYz() {
                this.isUpload = true
                this.isCommon = false
            },
        }
    }
</script>

<style scoped>
.content{
    width: 90%;
    margin: 50px auto 0;
}
.stepTwo-form{
    width: 100%;
    margin: 50px auto 0;
}
.upload-box{
    width: 200px;
    height: 200px;
    margin: 0 auto;
    border: 1px dashed #dcdee2;
    position: relative;
    text-align: center;
    padding-top: 85px;
}
.upload-box2{
    width: 200px;
    margin: 0 auto;
    position: relative;
}
.go-bind{
    text-align: center;
    margin-top: 20px;
}
.upload-zzc{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    position: absolute;
    top: 0;
    left: 0;
}
.user-img{
    width: 100%;
}
.upload-box i{
    font-size: 30px;
}
.upload-box:hover{
    border: 1px dashed #2d8cf0;
}
.imgFile{
    width: 200px;
    height: 200px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
.stepTwo-myphone{
    color: #000;
    margin-bottom: 15px;
}
    .stepTwo-content{
        margin-top: 50px;
    }
    .stepTow-tip{
        padding: 3px 5px;
        background: #bceaff;
        display: flex;
        align-items: center;
        color: #000;
        justify-content: center;
    }
    .stepTow-tip i{
        color: #2d8cf0;
        font-size: 26px;
        margin-right: 5px;
    }
.stepTow-tip a{
    color: #2d8cf0;
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// stepTwo.vue?0cc8dd83